// extracted by mini-css-extract-plugin
export var anchor = "_4q-0";
export var discard = "_4q-4";
export var muiTooltipTooltip = "_4q-6";
export var notificationBar = "_4q-3";
export var saveButtonHoverSlotWrapper = "_4q-5";
export var show = "_4q-2";
export var spacer = "_4q-1";